export default "__VITE_ASSET__ec0194fe__"